const background = ({ successColorPalette }) => successColorPalette[600];

export default background;
